<template>
  <!-- 点検情報編集 -->
  <div id="AppInspectionEdit">
    <inspection-edit ref="editContents" v-bind:inspection-code="inspectionCode" />
    <!-- 余白 -->
    <div style="height: 50px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <!-- 登録ボタン -->
      <b-button
        v-on:click="save"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >点検情報更新登録</b-button>
      <b-button
        v-on:click="saveMemo"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >メモ登録</b-button>
    </div>
    <!-- 下部余白(カレンダー表示用) -->
    <div style="height: 250px;" />
  </div>
</template>

<script>
import AppInspectionEditTemplate from "./AppInspectionEditContents";
export default {
  name: "AppInspectionEdit",
  methods: {
    back: function(event) {
      this.$router.push({
        name: "AppInspectionSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
    save: function(event) {
          var editContents = this.$refs.editContents;
      editContents.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          var result = editContents.save().then(result => {
            if (editContents.isSuccessEnd()) {
              this.back();
            }
          });
        } else {
          scrollTo(0, 0);
        }
      });
    },
    saveMemo: function(event) {
      var editContents = this.$refs.editContents;
      editContents.saveInspectionMemo();
    }
  },
  data() {
    var productCode = this.$route.params["productCode"];
    var patientCode = this.$route.params["patientCode"];
    var serial = this.$route.params["serial"];
    var searchConditions = this.$route.params["searchConditions"];
    var inspectionCode = this.$route.params["inspectionCode"];
    return {
      productCode,
      patientCode,
      serial,
      searchConditions,
      inspectionCode,
      inspectionMemo: ""
    };
  },
  components: {
    "inspection-edit": AppInspectionEditTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppInspectionEdit.vue